// @ts-nocheck

  import GlobalOutlined from '@ant-design/icons/es/icons/GlobalOutlined';
import TeamOutlined from '@ant-design/icons/es/icons/TeamOutlined';
import TableOutlined from '@ant-design/icons/es/icons/TableOutlined';
import SmileOutlined from '@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '@ant-design/icons/es/icons/CrownOutlined';
import DollarOutlined from '@ant-design/icons/es/icons/DollarOutlined';
import VideoCameraOutlined from '@ant-design/icons/es/icons/VideoCameraOutlined';
import ShopOutlined from '@ant-design/icons/es/icons/ShopOutlined';
import FireOutlined from '@ant-design/icons/es/icons/FireOutlined';
import Html5Outlined from '@ant-design/icons/es/icons/Html5Outlined'
  export default {
    GlobalOutlined,
TeamOutlined,
TableOutlined,
SmileOutlined,
CrownOutlined,
DollarOutlined,
VideoCameraOutlined,
ShopOutlined,
FireOutlined,
Html5Outlined
  }